// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__mOnd_","label":"SetPasswdForm_label__3-WOG"};